import React, {useCallback, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {replaceAutoHost, HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export const fileTree = Object.values({
  mainMap: [
    'main/advanced-obj1.png',
    'main/advanced-obj2.png',
    'main/advanced-obj3.png',
    'main/advanced-obj4.png',
    'main/advanced-obj5.png',
    'main/advanced-obj6.png',
    'main/advanced-obj7.png',
    'main/advanced-obj8.png',
    'main/master-obj1.png',
    'main/master-obj2.png',
    'main/master-obj3.png',
    'main/master-obj4.png',
    'main/master-obj5.png',
    'main/master-obj6.png',
    'main/master-obj7.png',
    'main/master-obj8.png',
    'main/normal-obj1.png',
    'main/normal-obj2.png',
    'main/normal-obj3.png',
    'main/normal-obj4.png',
    'main/normal-obj5.png',
    'main/normal-obj6.png',
    'main/normal-obj7.png',
    'main/normal-obj8.png',
  ] as const,
}).flat()

export function useConfConfig() {
  const {home} = useSelector((store) => store.Animal_Horse)
  const normalizeUrl = (url: string) => {
    // HTTPS 页面下，http 资源会触发混合内容拦截；这里改成协议无关形式
    return url.replace(/^https?:\/\//i, '//')
  }
  return useCallback(
    (key: typeof fileTree[number]) => {
      if (home?.ui_config?.[key]) {
        return normalizeUrl(replaceAutoHost(home.ui_config[key]))
      }
      return require(`./images/${key}`)
    },
    [home?.ui_config]
  )
}

// export const PagFile = {
//   转轴: `${HostMaps.auto.otherStatic}/static/1001/pag/转轴.pag`,
//   金币加彩带: `${HostMaps.auto.otherStatic}/static/1001/pag/金币加彩带.pag`,
//   跑车: `${HostMaps.auto.otherStatic}/static/1001/pag/跑车.pag`,
//   背光: `${HostMaps.auto.otherStatic}/static/1001/pag/jackpot背光.pag`,
// }
